// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
    ActivatedRoute,
    GuardsCheckEnd,
    GuardsCheckStart,
    NavigationCancel,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router,
    RouterEvent,
} from '@angular/router';
import { NavService } from '@services/nav.service';
import { ThemeService } from './theme/theme.service';
import { scrollIntoView } from './utils/utils';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewChecked {
    isLoading = false;
    isSigning: boolean;
    public onSystemDocPage = false;

    constructor(
        private readonly activatedRoute: ActivatedRoute,
        private cdref: ChangeDetectorRef,
        private readonly navService: NavService,
        private readonly router: Router,
        private readonly theme: ThemeService
    ) {
        this.router.events.subscribe((event: RouterEvent) => {
            switch (true) {
                case event instanceof NavigationStart: {
                    this.isLoading = true;
                    break;
                }
                case event instanceof GuardsCheckStart: {
                    this.isLoading = false;
                    break;
                }
                case event instanceof NavigationEnd:
                    this.onSystemDocPage = event.url.includes('systemDocument') ? true : false;
                    scrollIntoView('h1');
                    this.navService.setRouteState(this.activatedRoute.snapshot);
                    this.isLoading = false;
                    break;
                // eslint-disable-next-line no-fallthrough
                case event instanceof GuardsCheckEnd:
                    this.isLoading = true;
                    break;
                case event instanceof NavigationCancel:
                case event instanceof NavigationError:
                    this.isLoading = false;
                    break;
                default: {
                    break;
                }
            }
        });
        //commenting out because welcome email not redirecting to change password 01/06/2023
        //this.checkAppStatus();
    }

    ngOnInit(): void {
        this.setTheme();
    }

    ngAfterViewChecked(): void {
        this.cdref.detectChanges();
    }

    private setTheme(): void {
        // TODO eventually use location to determine the tenant
        // Currently DDJ & Stellantis use the same color theme
        // Default is the default DDJ color theme
        // if (getTenant) {
        //     //getTenant checks for URL includes Stellantis, EZ Docs Or E-SHOP
        //     this.theme.setTheme('default');
        // } else if (window.location.href.includes('chrysler')) {
        //     this.theme.setTheme('chrysler');
        // } else {
        //     this.theme.setTheme('default');
        // }

        this.theme.setTheme('default');
    }
}
